import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(0),
  },
  scrollBox: {
    height: `calc(80vh - 140px)`,
    display: 'flex',
    padding: `0px`,
    flexDirection: 'column',
  },
  tableContainer: {
    flex: '1 1 auto',
    margin: `${theme.spacing(2)} 0 0`,
    padding: `0px`,
    overflowY: 'hidden',
    height: '100%',
  },
  actionRow: {
    display: 'flex',
  },
  confirm: {
    margin: '0 0 0 12px',
  },
  button: {
    padding: '10px',
    fontSize: '8px',
    marginLeft: '30px',
  },
}));

export default useStyles;
